'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by fanjingjian on 17/9/22.
 */

var BUInfo = exports.BUInfo = {
    '10': 'mapLX2HipFood',
    '15': 'mapLX2HipLife',
    '30': 'mapLX2HipLife',
    '45': 'mapLX2HipLife',
    '55': 'mapLX2HipWed',
    '50': 'mapLX2HipBeauty',
    '70': 'mapLX2HipBaby',
    '90': 'mapLX2HipHome',
    '75': 'mapLX2HipEdu',
    '-1': 'mapLX2HipPoi'
};

var mapLX2HipBase = exports.mapLX2HipBase = {
    'b_9rhjmfrg': 'mshopinfoq_tuan', // 跳转m站团详
    'b_4gmg6ymk': 'mshopinfoq_viewreview', // 跳转m站评论列表
    'b_oi951fsu': 'mshopinfoq_tel', // 拨打电话
    'b_vty5n1ps': 'mshopinfoq_wedchat', // 跳转m站在线咨询
    'b_eqoypquu': 'mshopinfoq_wedbooking', // 唤起预约弹窗(通用吸底)
    'b_qdi5282k': 'mshopinfoq_wedbooking', // 唤起预约弹窗(礼模块)
    'b_m7x7f231': 'mshopinfoq_coupon', // 跳转优惠券领取页
    'b_myhpml27': 'shopyy_click', // 提交手机号
    'b_sg2rk0zl': 'lianmeng_pindao', // 跳转m站BU首页
    'b_f2ioafdo': 'mshopinfoq_address', // 跳转m站地图
    'b_a9j93shp': 'setlistdetail_click', // 查看高清大图

    'b_75hei48m': 'm_shop_serials_all', // 跳转m站套系列表
    'b_s53qtjri': 'mshopinfoq_wedbooking', // 唤起预约弹层(套系详情)
    'b_tarmrz30': 'mshopsetinfo_click', // 跳转m站套系详情
    'b_ryvibskh': '5_shopinfo_highquality_title', // 跳转结婚m站安心选(头部)
    'b_o8g2jwqv': '5_shopinfo_highquality_detail', // 跳转结婚m站安心选(内容)
    'b_fqibkulg': 'hunyan_m_schedule', // 查询宴会厅档期
    'b_qguy8fpm': 'hunyan_m_hall', // 查看更多宴会厅
    'b_pryp7nad': 'hunyan_m_hall', // 查看宴会厅图片

    'b_c72jsa6u': 'mshopinfoq_wedbooking', // 唤起预约弹层(亲子吸底)
    'b_bfz2iqg7': 'lianmeng_shipin', // 查看亲子视频
    'b_eursjeuu': 'mshopinfoq_product_more', // 跳转m站套系列表（亲子）
    'b_80lmkveg': 'mshopinfoq_product', // 跳转m站套系详情（亲子）
    'b_n1p7isb7': 'mshopinfoq_wedbooking', // 唤起预约弹层(亲子套系)

    'b_05vqqgjn': 'education_shop_course_booking', // 唤起预约弹窗(教培课程)
    'b_gr4y6bkw': 'education_shop_course_list', // 跳转m站课程列表
    'b_eno779ak': 'education_shop_course', // 跳转m站课程详情

    'b_nnpn2tqg': 'mshopinfoq_wedbooking', // 唤起预约弹窗(家装案例)
    'b_jh20l98m': 'shopinfoq_top_product_m', // 跳转m站家装案例
    'b_vwfokzn6': 'shopinfoq_top_productall_m', // 跳转m站案例列表页
    'b_69pd3as4': 'home_getbudget', // 跳转m站案例列表页
    'b_dywuwx88': 'home_shop_service', // 跳转m站案例列表页
    'b_79ytmfio': 'wedhome_design_noworry', // 跳转m站无忧装页
    'b_890x2s5v': 'home_special_services', // 跳转m站特色服务页

    'b_wbxfy9e4': 'beauty_yoga_dance', // 跳转m站丽人瑜伽舞蹈详情
    'b_5jxmedfj': 'mshopinfoq_tel', // 跳转m站丽人纹身预约页
    'b_l4nq02hp': 'beauty_tattoo' };

var mapLX2HipSpecial = exports.mapLX2HipSpecial = {
    mapLX2HipWed: {
        'b_sg2rk0zl': 'mshopinfoq_weddinghref' },
    mapLX2HipBaby: {
        // 'b_eursjeuu': 'mshopinfoq_product_more', // 跳转m站套系列表
    },
    mapLX2HipHome: {
        'b_qdi5282k': 'mshopinfoq_yuyue', // 唤起预约弹窗(礼模块)
        'b_myhpml27': 'button_submit', // 提交手机号
        'b_sg2rk0zl': 'lianmeng_pindao' },
    mapLX2HipEdu: {
        'b_9rhjmfrg': 'shopinfo_tuan', // 跳转m站团详
        'b_4gmg6ymk': 'shopinfo_viewreview', // 跳转m站评论列表
        'b_oi951fsu': 'shopinfo_tel', // 拨打电话
        'b_vty5n1ps': 'shopinfo_im', // 跳转m站在线咨询
        'b_eqoypquu': 'shopinfo_edu_booking', // 唤起预约弹窗(通用吸底)
        'b_qdi5282k': 'shopinfo_bookinggift', // 唤起预约弹窗(礼模块)
        'b_m7x7f231': '5_button_m_promo2', // 跳转优惠券领取页
        'b_f2ioafdo': 'shopinfo_address' },
    mapLX2HipBeauty: {},
    mapLX2HipLife: {},
    mapLX2HipFood: {},
    mapLX2HipPoi: {
        'b_q8dfpkpt': 'poidisplayad_loginwhengainpromo',
        'b_rw158iva': 'poi_header_bar_handle',
        'b_repyq6sv': 'poi_header_bar_success',
        'b_5vwjeyit': 'poidisplayad_singlecomment',
        'b_mejnrzeu': 'poidisplayad_totalcomment',
        'b_9j5b0vs7': 'poidisplayad_swipe',
        'b_a95y06h4': 'poidisplayad_voice',
        'b_pb9d0xd0': 'poidisplayad_playvideo',
        'b_3hdjpk8t': 'poidisplayad_videoisplaying',
        'b_aasx1xyo': 'poidisplayad_imageclick',
        'b_dyre224c': 'poidisplayad_lightspot',
        'b_7e8esqvh': '',
        'b_l6lbstbs': '',
        'b_pdnjvjh1': 'poidisplayad_recommend',
        'b_0vez2o8l': 'poidisplayad_groupbuy',
        'b_qocd2mgu': 'poidisplayad_voucher',
        'b_yyw06xsn': 'poidisplayad_gainpromodetail',
        'b_0ocat6g2': 'poidisplayad_gainpromo',
        'b_ba9uzw3p': '',
        'b_af3n5cax': '',
        'b_p8hj0uvq': 'poidisplayad_tel',
        'b_5lc2blu4': 'poidisplayad_addfavor',
        'b_ohmif19n': 'poidisplayad_loginwhenaddfavor',
        'b_u61d1vg9': 'poidisplayad_deletefavor',
        'b_7dozanls': 'poidisplayad_subbranch',
        'b_zkkqipve': 'poidisplayad_address',
        'b_l7n5ohy4': 'poidisplayad_brandstory',
        'b_aoed47mu': 'poidisplayad_brandstory'
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cp-component-lib/lib/config/lx2hip.config.js
// module id = 238
// module chunks = 0